import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a9911d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = {
  key: 1,
  class: "detail"
}
const _hoisted_4 = {
  id: "list_wapper",
  class: "flex-1"
}
const _hoisted_5 = { class: "ctitle" }
const _hoisted_6 = { class: "flex" }

import API from "@/api/machine/index";
import JIcom from "@/components/jicon/index.vue";
import { onMounted, ref, watch, nextTick } from "vue";
import Sortable from "sortablejs"
interface orderItemInfo {
    /**
     * 字段id
     */
    id: number;
    /**
     * 字段含义
     */
    title: string;
    /**
     * 字段含义
     */
    context?: string;
    /**
     * 是否展示
     */
    show: boolean;
}

//---------------------传入参数、回调、监听定义---------------------
//定义传入变量

export default /*#__PURE__*/_defineComponent({
  __name: 'configFiles2',
  props: {
    id: {
        required: true,
        type: Number,
    },
    visible: {
        required: true,
        type: Boolean,
    },
    title: {
        required: false,
        type: String,
        default: "产品信息"
    },
    detail: {
        required: false,
        type: String,
        default: "长按可拖动进行排序"
    },
},
  emits: ["result"],
  setup(__props, { emit }: { emit: ({
    //切换选项卡
    (e: "result", state: "close" | "complent"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;




//-----------------变量定义-------------------
let list = ref<orderItemInfo[]>([]);

let palnlist = ref<any>(null);
const cleanSelectItem = () => {
    return {
        id: -1,
        title: '',
        show: false
    }
}
// 选中元素内容
let selectitem = ref<orderItemInfo>(cleanSelectItem());

//------------------监听数据变化-------------
watch(
    () => props.id,// 函数方式监听对象里的值
    (newVal) => {
        getDataList(newVal)
    }
);


//定义回调事件



//定义生命周期事件
onMounted(() => {
    //生命周期处理内容
    if (props.id && props.id !== -1) {
        getDataList(props.id)
    }
    nextTick(() => {
        // 加载完成之后在绑定拖动事件
        rowDrop2()
    });
});

//-----------------方法定义-------------------
const getDataList = (id: number) => {
    API.postMachineProductionGetConfigurableFieldBySonId({ sonFieldShowId: id }).then((rep) => {
        list.value = rep.list.map((e) => {
            return { id: e.fieldId, title: e.fieldMean, show: e.isShwo === 'y' ? true : false }
        });
    })
};

const onCloseConfigFileds = () => {
    emit("result", "close");
    list.value = []
}

//切换顺序
const switchOrder = (checked: number) => {
    let orderItem = list.value[checked];
    //先把自己从列表中移除
    list.value.splice(checked, 1);
    let lastPostion = 0;
    for (let index = 0; index < list.value.length; index++) {
        const element = list.value[index];
        if (!element.show) {
            //移动位置到这里来
            list.value.splice(index, 0, orderItem);
            break;
        }
        lastPostion = index + 1;
    }
    if (lastPostion === list.value.length) {
        list.value.push(orderItem)
    }
}
const onConfig = () => {
    // /**
    // 	 * 字段id：需要按顺序传入
    // 	 */
    //      fieldIdList: string[];
    // 	/**
    // 	 * 第二级id
    // 	 */
    // 	sonFieldId: number;
    //配置顺序

    let fieldIdList: string[] = list.value.filter((e) => {
        return e.show;
    }).map((e) => {
        return e.id + ''
    })

    API.postMachineProductionSetFieldShow({ sonFieldId: props.id, fieldIdList: fieldIdList }).then((e) => {
        emit("result", "complent");
        list.value = []

    })
}
const oldIndex = ref<number>(null)
const newIndex = ref<number>(null)
//产品信息拖动
const rowDrop2 = () => {
    const el = document.getElementById("list_wapper");
    new Sortable(el, {
        sort: true,
        animation: 250, //动画
        handle: ".sortIcon", // 允许拖拽的项目类名
        onEnd(evt) {
            newIndex.value = evt.newIndex;
            oldIndex.value = evt.oldIndex;
            const newArray = list.value;
            const currRow = newArray.splice(oldIndex.value, 1)[0];
            newArray.splice(newIndex.value, 0, currRow);
            list.value = [];
            nextTick(() => {
                list.value = [...newArray];
            });
            //   拖拽完成，初始位置及目标位置重置
            newIndex.value = null;
            oldIndex.value = null;
        },
    });
}


return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    width: _ctx.$px2rem(500),
    placement: "right",
    visible: __props.visible,
    destroyOnClose: true,
    closable: false,
    onClose: onCloseConfigFileds
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1))
          : _createCommentVNode("", true),
        (__props.detail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.detail), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "libox",
              key: item.id
            }, [
              _withDirectives(_createVNode(JIcom, {
                class: "sortIcon",
                icon: "mes-paixu",
                size: _ctx.$px2rem('32px')
              }, null, 8, ["size"]), [
                [_vShow, item.id !== _unref(selectitem).id]
              ]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
              _createVNode(_component_a_switch, {
                class: "cdetail",
                checked: item.show,
                "onUpdate:checked": ($event: any) => ((item.show) = $event),
                onChange: ($event: any) => (switchOrder(index))
              }, null, 8, ["checked", "onUpdate:checked", "onChange"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_button, {
            class: "flex-1 basebtn",
            onClick: onCloseConfigFileds
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            class: "flex-1 basebtn cancel",
            type: "primary",
            onClick: onConfig
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["width", "visible"]))
}
}

})